import { FormInstance } from 'antd';

export interface IBeFormError {
	status: string;
	message: string;
	errors: Record<string, Record<string, string>>;
}

export const handleFormErrorResponse = (e: any, form: FormInstance) => {
	if (e?.data?.errors) {
		try {
			const data: IBeFormError = e?.data;

			const formattedErrors = Object.entries(data.errors).map(([field, fieldErrorMap]) => ({
				name: field,
				errors: Object.values(fieldErrorMap),
			}));

			form.setFields(formattedErrors);
		} catch (e) {}
	}
};
